// extracted by mini-css-extract-plugin
export default {"row":"Channels_row__FPm9z"};